if (localStorage.getItem("token") != null) {
  window.location = "drawlist.html";
}